import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export enum TechTierPrice {
    Cost,
    Research,
    Score
}

export class UpdateTechTierPriceCommand extends CommandBase {
    tier: number;
    price: number;
    type: TechTierPrice;

    constructor(tier: number, price: number, type: TechTierPrice) {
        super();
        this.tier = tier;
        this.price = price;
        this.type = type;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (data.techConfig === undefined) {
            data.techConfig = {
                prices: [],
                researchTimes: [],
                playerScores: []
            };
        }

        const config = data.techConfig;
        switch (this.type) {
            case TechTierPrice.Cost:
                config.prices = this.insert(config.prices);
                return true;
            case TechTierPrice.Research:
                config.researchTimes = this.insert(config.researchTimes);
                return true;
            case TechTierPrice.Score:
                config.playerScores = this.insert(config.playerScores);
                return true;
            default:
                return false;
        }
    }

    private insert(prices: number[]): number[] {
        if (!prices) {
            prices = [];
        }

        const len = prices.length;
        if (this.tier >= len) {
            for (let i = 0; i < this.tier - len; i++) {
                prices[len + i] = 0;
            }
        }

        prices[this.tier] = this.price;
        return prices;
    }
}